// Types
import { Preferences } from '../../profile/objects/preferences';
import { AutomaticProductLocalized } from '../objects/automaticProductLocalized';
import { AutomaticProductState } from '../objects/automaticProductState';
import { Column } from '../objects/column';
// Action Types
import { Picture } from '../../picture/objects/picture';
import { ADD_CUSTOM_PICTURES, PictureActionTypes } from '../../picture/redux/actionTypes';
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';
import { DEFAULT_COLUMN } from '../constant/column';
import {
    ADD_COUNTRY_PRICE,
    ADD_PREFERENCES,
    AutomaticProductActionTypes,
    DELETE_COUNTRY_PRICE,
    DELETE_PICTURE,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_ADD_PRODUCT,
    RESET_FILTERS,
    SET_AUTOMATIC_PRODUCT_DELETE,
    SET_AUTOMATIC_PRODUCT_DUPLICATE,
    SET_PREFERENCES as SET_AUTOMATIC_PRODUCT_PREFERENCES,
    SET_COLUMNS,
    SET_EDIT_STEP,
    SET_ERRORS,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PRODUCT,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_CANCEL_MODAL,
    TOGGLE_COLUMN,
    TOGGLE_CREATE,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_PICTURES_ORDER,
    TOGGLE_REFRESH,
    UPDATE_AGENCY_CREATOR_ONLY,
    UPDATE_ALLOWED_DESTINATION,
    UPDATE_CURRENCY,
    UPDATE_DESCRIPTION_LOCALE,
    UPDATE_EVENT_SITES,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_DESTINATION,
    UPDATE_FILTER_EVENT,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_FIX_TRIP_PRICE,
    UPDATE_FIX_TRIP_PAX_PRICE,
    UPDATE_HAS_DELETION_RESTRICTION,
    UPDATE_IATA_COUNTRIES,
    UPDATE_IS_BOOKABLE,
    UPDATE_IS_DISPLAYED,
    UPDATE_IS_HIDDEN_FOR_TRAVELERS,
    UPDATE_IS_MARGIN_EDITABLE_BY_AGENCY,
    UPDATE_IS_OPTIONAL,
    UPDATE_IS_PRICE_EDITABLE,
    UPDATE_IS_PRICE_EDITABLE_SELLER,
    UPDATE_IS_PRICE_PER_DAY,
    UPDATE_IS_PRICE_PER_PAX,
    UPDATE_IS_PRICE_PER_ROOM,
    UPDATE_IS_SURCOM_APPLICABLE,
    UPDATE_IS_SURCOM_ONLY,
    UPDATE_LIST_ITEM_ACTIVATION,
    UPDATE_MAX_TRIP_PAX_PRICE,
    UPDATE_MAX_TRIP_PRICE,
    UPDATE_MIN_TRIP_PAX_PRICE,
    UPDATE_MIN_TRIP_PRICE,
    UPDATE_NAME_LOCALE,
    UPDATE_NO_AUTO_ADD,
    UPDATE_PICTURE_ORDER,
    UPDATE_PRICE_TYPE,
    UPDATE_PRODUCT_CODE,
    UPDATE_PRODUCT_TYPE,
    UPDATE_PROVIDER,
    UPDATE_PROVIDER_NAME,
    UPDATE_PURCHASE_CURRENCY,
    UPDATE_PURCHASE_CURRENCY_COUNTRY,
    UPDATE_PURCHASE_PRICE,
    UPDATE_PURCHASE_PRICE_COUNTRY,
    UPDATE_SELLING_PRICE,
    UPDATE_SELLING_PRICE_COUNTRY,
    UPDATE_TO_CREATOR_ONLY,
    UPDATE_TVA_PERCENTAGE,
    UPDATE_SELLING_PRICE_PERCENTAGE,
    UPDATE_SELLING_PRICE_TYPE,
    UPDATE_TVA_PERCENTAGE_COUNTRY,
    UPDATE_PURCHASE_PRICE_PERCENTAGE,
    UPDATE_PURCHASE_PRICE_TYPE
} from './actionTypes';

const initialState: AutomaticProductState = {
    agency_creator_only: false,
    allowed_destinations: [],
    automatic_product_delete: null,
    automatic_product_duplicate: null,
    cancel_modal: false,
    columns: DEFAULT_COLUMN,
    count: 0,
    country_prices: [],
    create: false,
    currency: null,
    custom_pictures: [],
    description_locales: {},
    edit_step: null,
    editor_pictures: null,
    errors: [],
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    event_sites: [],
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_creator: '',
    filter_destination: null,
    filter_event: null,
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_open: false,
    filter_period: 'CREATION',
    filter_period_type: 0,
    has_deletion_restriction: false,
    is_bookable: true,
    is_displayed: true,
    is_hidden_for_travelers: false,
    is_hidden_for_traveler_count_price: false,
    is_margin_editable_by_agency: false,
    is_optional: false,
    is_price_editable: true,
    is_price_editable_seller: true,
    is_price_per_day: false,
    is_price_per_pax: false,
    is_price_per_room: false,
    is_surcom_applicable: false,
    is_surcom_only: false,
    limit: 50,
    list: [],
    fix_trip_pax_price: '',
    fix_trip_price: '',
    max_trip_pax_price: '',
    max_trip_price: '',
    min_trip_pax_price: '',
    min_trip_price: '',
    name_locales: {},
    no_auto_add: false,
    order: 'asc',
    order_by: 'name',
    page: 0,
    pictures: [],
    pictures_order: false,
    preferences: [],
    price_type: 'min-price',
    product: null,
    product_code: '',
    product_type: '',
    provider: null,
    provider_name: '',
    purchase_currency: null,
    purchase_price: '',
    refresh: false,
    running: false,
    search: '',
    selling_price: '',
    tva_percentage: '',
    selling_price_percentage: '',
    selling_price_type: 'FIX',
    purchase_price_percentage: '',
    purchase_price_type: 'FIX',
    to_creator_only: false
};

export default (state:AutomaticProductState = initialState, action: AutomaticProductActionTypes | PictureActionTypes | ProfileActionTypes): AutomaticProductState => {
    switch (action.type) {
        case ADD_CUSTOM_PICTURES: {
            if (state.create || state.edit_step === 'PICTURES') {
                return { ...state, pictures: [...state.pictures, ...action.payload] };
            }
            return state;
        }
        case ADD_PREFERENCES: {
            return { ...state, preferences: [...state.preferences, ...action.payload] };
        }
        case ADD_COUNTRY_PRICE: {
            const country_prices = [...state.country_prices];
            country_prices.push({
                country: [],
                purchase_price: '',
                purchase_currency: null,
                selling_price: '',
                tva_percentage: ''
            });
            return { ...state, country_prices: country_prices };
        }
        case DELETE_COUNTRY_PRICE: {
            const country_prices = [...state.country_prices];
            country_prices.splice(action.payload, 1);
            return { ...state, country_prices: country_prices };
        }
        case DELETE_PICTURE: {
            return { ...state, pictures: state.pictures.reduce((acc:Picture[], picture, index)=> {index !==action.payload && acc.push(picture); return acc;},[] as Picture[]) };
        }
        case MOVE_DOWN_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload + 1] };
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case MOVE_UP_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload - 1] };
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case RESET_ADD_PRODUCT: {
            return {
                ...state,
                agency_creator_only: false,
                allowed_destinations: [],
                create: false,
                cancel_modal: false,
                country_prices: [],
                custom_pictures: [],
                description_locales: {},
                editor_pictures: null,
                edit_step: null,
                errors: [],
                is_optional: false,
                is_hidden_for_travelers: false,
                is_hidden_for_traveler_count_price: false,
                has_deletion_restriction: false,
                event_sites: [],
                is_margin_editable_by_agency: false,
                is_surcom_applicable: false,
                is_surcom_only: false,
                is_price_editable: true,
                is_price_editable_seller: true,
                is_price_per_day: false,
                is_price_per_pax: false,
                is_price_per_room: false,
                fix_trip_pax_price: '',
                fix_trip_price: '',
                max_trip_pax_price: '',
                max_trip_price: '',
                min_trip_pax_price: '',
                min_trip_price: '',
                name_locales: {},
                pictures: [],
                pictures_order: false,
                price_type: 'min-price',
                product: null,
                product_code: '',
                product_type: '',
                provider: null,
                provider_name: '',
                purchase_price: '',
                purchase_currency: null,
                selling_price: '',
                tva_percentage: '',
                selling_price_percentage: '',
                selling_price_type: 'FIX',
                purchase_price_percentage: '',
                purchase_price_type: 'FIX',
                to_creator_only: false
            };
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_creator: '',
                filter_destination: null,
                filter_event: null,
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
            };
        }
        case SET_AUTOMATIC_PRODUCT_DELETE: {
            if (action.payload === null && state.automatic_product_delete !== null && state.list !== null) {
                const list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === state.automatic_product_delete.id) {
                        list.splice(i, 1);
                        return { ...state, automatic_product_delete: action.payload === false ? null : action.payload, list: list, count: state.count - 1 };
                    }
                }
            }
            return { ...state, automatic_product_delete: action.payload === false ? null : action.payload };
        }
        case SET_AUTOMATIC_PRODUCT_DUPLICATE: {
            return { ...state, automatic_product_duplicate: action.payload };
        }
        case SET_EDIT_STEP: {
            return { ...state, edit_step: action.payload, errors: [] };
        }
        case SET_ERRORS: {
            return { ...state, errors: action.payload };
        }
        case SET_EXPORT_TYPE: {
            return { ...state, export_type: action.payload };
        }
        case SET_LIMIT: {
            return { ...state, list: null, limit: action.payload };
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return { ...state, count: count, list: results, running: false };
        }
        case SET_ORDER_BY: {
            return { ...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_COLUMNS: {
            return { ...state, columns: action.payload };
        }
        case SET_PAGE: {
            return { ...state, list: null, page: action.payload };
        }
        case SET_PREFERENCES: {
            const preferences = action.payload;
            const new_columns: Column[] = [];
            let new_order_by = '-created_date';
            let new_order: 'asc' | 'desc' = 'asc';
            const field_name: string[] = [];
            const automatic_product_preferences: Preferences[] = [];
            preferences.map(preference => {
                if (preference.module === 'AUTOMATIC_PRODUCT') {
                    if (!field_name.includes(preference.field_name)) {
                        switch (preference.field_name) {
                            case 'NAME':
                                new_columns.push({ label: 'name', field_name: preference.field_name, checked: preference.active, order_by: 'name', fixed_width: false, last_updated: false });
                                new_order_by = preference.ordering_asc !== null ? 'name' : new_order_by;
                                break;
                            case 'STATUS':
                                new_columns.push({ label: 'status', field_name: preference.field_name, checked: preference.active, order_by: 'is_active', fixed_width: true, last_updated: false });
                                new_order_by = preference.ordering_asc !== null ? 'is_active' : new_order_by;
                                break;
                            case 'CREATED_DATE':
                                new_columns.push({ label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false });
                                new_order_by = preference.ordering_asc !== null ? 'created_date' : new_order_by;
                                break;
                            case 'CREATED_BY':
                                new_columns.push({ label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false });
                                new_order_by = preference.ordering_asc !== null ? 'creator__username' : new_order_by;
                                break;
                            case 'MODIFIED_DATE':
                                new_columns.push({ label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false });
                                new_order_by = preference.ordering_asc !== null ? 'modified_date' : new_order_by;
                                break;
                            case 'MODIFIED_BY':
                                new_columns.push({ label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false });
                                new_order_by = preference.ordering_asc !== null ? 'last_author__username' : new_order_by;
                                break;
                            default:
                                break;
                        }
                        automatic_product_preferences.push(preference);
                        field_name.push(preference.field_name);
                        new_order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : new_order;
                    }
                }
            });
            if (new_columns.length !== state.columns.length) {
                state.columns.map(column => {
                    let added = false;
                    for (let i = 0; i < new_columns.length; i++) {
                        if (new_columns[i].label === column.label) {
                            added = true;
                            break;
                        }
                    }
                    if (!added) {
                        new_columns.push({ ...column });
                    }
                });
            }
            return { ...state, preferences: automatic_product_preferences, columns: new_columns, order_by: new_order_by, order: new_order };
        }
        case SET_AUTOMATIC_PRODUCT_PREFERENCES: {
            return { ...state, preferences: action.payload };
        }
        case SET_PRODUCT: {
            if (action.payload !== null) {
                const product = action.payload;
                const name_locale: {} & {[index: string]: any} = {};
                const description_locale: {} & {[index: string]: any} = {};
                let has_french = false;
                product.localization.map((locale: AutomaticProductLocalized) => {
                    if (locale.locale === 1) {
                        has_french = true;
                    }
                    name_locale[locale.locale] = locale.name;
                    description_locale[locale.locale] = locale.description;
                });
                if (!has_french) {
                    name_locale['1'] = product.name !== null ? product.name : '';
                }
                return {
                    ...state,
                    agency_creator_only: product.agency_creator_only,
                    allowed_destinations: product.allowed_destinations,
                    country_prices: product.country_prices,
                    description_locales: description_locale,
                    has_deletion_restriction: product.has_deletion_restriction,
                    event_sites: product.event_sites || [],
                    is_bookable: product.is_bookable,
                    is_displayed: product.is_displayed,
                    is_hidden_for_traveler_count_price: product.is_hidden_for_traveler_count_price,
                    is_margin_editable_by_agency: product.is_margin_editable_by_agency,
                    is_optional: product.is_optional,
                    is_price_per_day: product.is_price_per_day,
                    is_price_per_pax: product.is_price_per_pax,
                    is_price_per_room: product.is_price_per_room,
                    is_surcom_applicable: product.is_surcom_applicable,
                    is_surcom_only: product.is_surcom_only,
                    is_price_editable: product.is_price_editable,
                    is_price_editable_seller: product.is_price_editable_seller,
                    fix_trip_pax_price: product.max_trip_pax_price === null ? (product.min_trip_pax_price !== null ? product.min_trip_pax_price : '') : '',
                    fix_trip_price: product.max_trip_price === null ? (product.min_trip_price !== null ? product.min_trip_price : '') : '',
                    max_trip_pax_price: product.max_trip_pax_price !== null ? product.max_trip_pax_price : '',
                    max_trip_price: product.max_trip_price !== null ? product.max_trip_price : '',
                    min_trip_pax_price: (product.max_trip_pax_price !== null && product.min_trip_pax_price !== null) ? product.min_trip_pax_price : '',
                    min_trip_price: (product.max_trip_price !== null && product.min_trip_price !== null) ? product.min_trip_price : '',
                    name_locales: name_locale,
                    no_auto_add: product.no_auto_add,
                    pictures: product.picture !== null ? [product.picture] : [],
                    price_type: (product.max_trip_pax_price !== null || product.max_trip_price !== null) ? 'range-price' : 'min-price',
                    product_code: product.product_code,
                    product_type: product.product_type,
                    product: action.payload,
                    purchase_currency: product.purchase_currency,
                    tva_percentage: product.tva_percentage !== null ? product.tva_percentage : '',
                    selling_price_percentage: product.selling_price_type === 'PER' ? product.selling_price || '' : '',
                    selling_price: product.selling_price_type === 'FIX' ? product.selling_price || '' : '',
                    selling_price_type: product.selling_price_type || 'FIX',
                    purchase_price_percentage: product.purchase_price_type === 'PER' ? product.purchase_price || '' : '',
                    purchase_price: product.purchase_price_type === 'FIX' ? product.purchase_price || '' : '',
                    purchase_price_type: product.purchase_price_type || 'FIX',
                    to_creator_only: product.to_creator_only,
                    provider_name: product.provider_name !== null ? product.provider_name : '',
                    provider: product.provider !== null ? { provider: product.provider } : null
                };
            }
            return state;
        }
        case SET_RUNNING: {
            return { ...state, running: action.payload };
        }
        case SET_SEARCH: {
            return { ...state, search: action.payload, page: 0 };
        }
        case TOGGLE_CANCEL_MODAL: {
            return { ...state, cancel_modal: !state.cancel_modal };
        }
        case TOGGLE_COLUMN: {
            const columns = [...state.columns];
            const column = { ...columns[action.payload] };
            column.checked = !column.checked;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case TOGGLE_CREATE: {
            return { ...state, create: !state.create };
        }
        case TOGGLE_EXPORT: {
            return { ...state, export_list: action.payload };
        }
        case TOGGLE_EXPORT_FULL: {
            return { ...state, export_full: !state.export_full };
        }
        case TOGGLE_FILTERS: {
            return { ...state, filter_open: !state.filter_open };
        }
        case TOGGLE_PICTURES_ORDER: {
            return { ...state, pictures_order: !state.pictures_order };
        }
        case TOGGLE_REFRESH: {
            return { ...state, refresh: !state.refresh };
        }
        case UPDATE_AGENCY_CREATOR_ONLY: {
            // const agency_creator_only = !state.agency_creator_only;
            // const to_creator_only = agency_creator_only ? false : state.to_creator_only;
            // return { ...state, agency_creator_only: agency_creator_only, to_creator_only: to_creator_only };
            return { ...state, agency_creator_only: !state.agency_creator_only };
        }
        case UPDATE_ALLOWED_DESTINATION: {
            return { ...state, allowed_destinations: action.payload };
        }
        case UPDATE_CURRENCY: {
            return { ...state, currency: action.payload };
        }
        case UPDATE_DESCRIPTION_LOCALE: {
            const { id, value } = action.payload;
            const description_locales = { ...state.description_locales };
            description_locales[id] = value;
            return { ...state, description_locales: description_locales };
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return { ...state, filter_created_date_gte: action.payload };
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return { ...state, filter_created_date_lte: action.payload };
        }
        case UPDATE_FILTER_CREATOR: {
            return { ...state, filter_creator: action.payload };
        }
        case UPDATE_FILTER_DESTINATION: {
            return { ...state, filter_destination: action.payload };
        }
        case UPDATE_FILTER_EVENT: {
            return { ...state, filter_event: action.payload };
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return { ...state, filter_last_author: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return { ...state, filter_modified_date_gte: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return { ...state, filter_modified_date_lte: action.payload };
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_created_date_gte: period === 'MODIFICATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period === 'MODIFICATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period === 'CREATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period === 'CREATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return { ...state, filter_period_type: action.payload };
        }
        case UPDATE_FIX_TRIP_PRICE: {
            return {...state, fix_trip_price: action.payload, max_trip_price: '', min_trip_rice: '', fix_trip_pax_price: '', max_trip_pax_price: '', min_trip_pax_price: ''};
        }
        case UPDATE_FIX_TRIP_PAX_PRICE: {
            return {...state, fix_trip_pax_price: action.payload, max_trip_pax_price: '', min_trip_pax_price: '', fix_trip_price: '', max_trip_price: '', min_trip_price: ''};
        }
        case UPDATE_HAS_DELETION_RESTRICTION: {
            return { ...state, has_deletion_restriction: !state.has_deletion_restriction };
        }
        case UPDATE_IATA_COUNTRIES: {
            const country_prices = [...state.country_prices];
            const price = { ...country_prices[action.payload.index] };
            price.country = action.payload.value;
            country_prices[action.payload.index] = price;
            return { ...state, country_prices: country_prices };
        }
        case UPDATE_IS_BOOKABLE: {
            return { ...state, is_bookable: !state.is_bookable };
        }
        case UPDATE_IS_DISPLAYED: {
            return { ...state, is_displayed: !state.is_displayed, is_hidden_for_traveler_count_price: state.is_hidden_for_traveler_count_price ? !state.is_hidden_for_traveler_count_price : state.is_hidden_for_traveler_count_price };
        }
        case UPDATE_IS_PRICE_EDITABLE: {
            return { ...state, is_price_editable: !state.is_price_editable };
        }
        case UPDATE_IS_PRICE_EDITABLE_SELLER: {
            return { ...state, is_price_editable_seller: !state.is_price_editable_seller };
        }
        case UPDATE_IS_OPTIONAL: {
            return { ...state, is_optional: !state.is_optional };
        }
        case UPDATE_IS_HIDDEN_FOR_TRAVELERS: {
            console.log('state.is_displayed:', state.is_displayed);
            return { ...state, is_hidden_for_traveler_count_price: !state.is_hidden_for_traveler_count_price, is_displayed: !state.is_displayed ? !state.is_displayed : state.is_displayed };
        }
        case UPDATE_IS_MARGIN_EDITABLE_BY_AGENCY: {
            return { ...state, is_margin_editable_by_agency: !state.is_margin_editable_by_agency };
        }
        case UPDATE_IS_SURCOM_APPLICABLE: {
            return { ...state, is_surcom_applicable: !state.is_surcom_applicable, is_surcom_only: !state.is_surcom_applicable ? false : state.is_surcom_only };
        }
        case UPDATE_IS_SURCOM_ONLY: {
            return { ...state, is_surcom_only: !state.is_surcom_only, is_surcom_applicable: !state.is_surcom_only ? false : state.is_surcom_applicable };
        }
        case UPDATE_IS_PRICE_PER_DAY: {
            const is_price_per_day = !state.is_price_per_day;
            const is_price_per_pax = is_price_per_day ? false : state.is_price_per_pax;
            return { ...state, is_price_per_day: is_price_per_day, is_price_per_pax: is_price_per_pax, is_price_per_room: !state.is_price_per_day? false: state.is_price_per_room } ;
        }
        case UPDATE_IS_PRICE_PER_PAX: {
            const is_price_per_pax = !state.is_price_per_pax;
            const is_price_per_day = is_price_per_pax ? false : state.is_price_per_day;
            return { ...state, is_price_per_pax: is_price_per_pax, is_price_per_day: is_price_per_day, is_price_per_room: !state.is_price_per_pax? false: state.is_price_per_room };
        }
        case UPDATE_IS_PRICE_PER_ROOM: {
            return { ...state, is_price_per_room: !state.is_price_per_room, is_price_per_pax: !state.is_price_per_room? false: state.is_price_per_pax, is_price_per_day: !state.is_price_per_room? false: state.is_price_per_day };
        }
        case UPDATE_LIST_ITEM_ACTIVATION: {
            if (state.list !== null) {
                const list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === action.payload.id) {
                        list[i] = action.payload;
                        return { ...state, list: list };
                    }
                }
            }
            return state;
        }
        case UPDATE_MAX_TRIP_PAX_PRICE: {
            return {...state, max_trip_pax_price: action.payload, fix_trip_pax_price: '', fix_trip_price: '', min_trip_price: '', max_trip_price: ''}
        }
        case UPDATE_MAX_TRIP_PRICE: {
            return {...state, max_trip_price: action.payload, fix_trip_price: '', fix_trip_pax_price: '', max_trip_pax_price: '', min_trip_pax_price: ''}
        }
        case UPDATE_MIN_TRIP_PAX_PRICE: {
            return {...state, min_trip_pax_price: action.payload, fix_trip_pax_price: '', fix_trip_price: '', min_trip_price: '', max_trip_price: ''}
        }
        case UPDATE_MIN_TRIP_PRICE: {
            return {...state, min_trip_price: action.payload, fix_trip_pax_price: '', fix_trip_price: '', min_trip_pax_price: '', max_trip_pax_price: ''}
        }
        case UPDATE_NAME_LOCALE: {
            const { id, value } = action.payload;
            const name_locales = { ...state.name_locales };
            name_locales[id] = value;
            return { ...state, name_locales: name_locales };
        }
        case UPDATE_NO_AUTO_ADD: {
            return { ...state, no_auto_add: !state.no_auto_add };
        }
        case UPDATE_PICTURE_ORDER: {
            const { drag_index, hover_index } = action.payload;
            const pictures = [...state.pictures];
            pictures.splice(drag_index, 1);
            pictures.splice(hover_index, 0, state.pictures[drag_index]);
            return { ...state, pictures: pictures };
        }
        case UPDATE_PRICE_TYPE: {
            return { ...state, price_type: action.payload };
        }
        case UPDATE_PRODUCT_CODE: {
            return { ...state, product_code: action.payload };
        }
        case UPDATE_PRODUCT_TYPE: {
            return { ...state, product_type: action.payload };
        }
        case UPDATE_PROVIDER: {
            return { ...state, provider: action.payload, provider_name: '' };
        }
        case UPDATE_PROVIDER_NAME: {
            return { ...state, provider: null, provider_name: action.payload };
        }
        case UPDATE_PURCHASE_CURRENCY: {
            return { ...state, purchase_currency: action.payload };
        }
        case UPDATE_EVENT_SITES: {
            return { ...state, event_sites: action.payload };
        }
        case UPDATE_PURCHASE_CURRENCY_COUNTRY: {
            if (action.payload.index !== null) {
                const country_prices = [...state.country_prices];
                const price = { ...country_prices[action.payload.index] };
                price.purchase_currency = action.payload.value;
                country_prices[action.payload.index] = price;
                return { ...state, country_prices: country_prices };
            }
            return state;
        }
        case UPDATE_PURCHASE_PRICE: {
            return { ...state, purchase_price: action.payload };
        }
        case UPDATE_PURCHASE_PRICE_COUNTRY: {
            if (action.payload.index !== null) {
                const country_prices = [...state.country_prices];
                const price = { ...country_prices[action.payload.index] };
                price.purchase_price = action.payload.value;
                country_prices[action.payload.index] = price;
                return { ...state, country_prices: country_prices };
            }
            return state;
        }
        case UPDATE_SELLING_PRICE: {
            return { ...state, selling_price: action.payload };
        }
        case UPDATE_SELLING_PRICE_COUNTRY: {
            if (action.payload.index !== null) {
                const country_prices = [...state.country_prices];
                const price = { ...country_prices[action.payload.index] };
                price.selling_price = action.payload.value;
                country_prices[action.payload.index] = price;
                return { ...state, country_prices: country_prices };
            }
            return state;
        }
        case UPDATE_TVA_PERCENTAGE: {
            return { ...state, tva_percentage: action.payload };
        }
        case UPDATE_SELLING_PRICE_PERCENTAGE: {
            return { ...state, selling_price_percentage: action.payload };
        }
        case UPDATE_SELLING_PRICE_TYPE: {
            return { ...state, selling_price_type: action.payload };
        }
        case UPDATE_PURCHASE_PRICE_PERCENTAGE: {
            return { ...state, purchase_price_percentage: action.payload };
        }
        case UPDATE_PURCHASE_PRICE_TYPE: {
            return { ...state, purchase_price_type: action.payload };
        }
        case UPDATE_TVA_PERCENTAGE_COUNTRY: {
            if (action.payload.index !== null) {
                const country_prices = [...state.country_prices];
                const price = { ...country_prices[action.payload.index] };
                price.tva_percentage = action.payload.value;
                country_prices[action.payload.index] = price;
                return { ...state, country_prices: country_prices };
            }
            return state;
        }
        case UPDATE_TO_CREATOR_ONLY: {
            // const to_creator_only = !state.to_creator_only;
            // const agency_creator_only = to_creator_only ? false : state.agency_creator_only;
            // return { ...state, agency_creator_only: agency_creator_only, to_creator_only: to_creator_only };
            return { ...state, to_creator_only: !state.to_creator_only };
        }
        default:
            return state;
    }
};